import { render, staticRenderFns } from "./LedesList.vue?vue&type=template&id=a0f09370&"
import script from "./LedesList.vue?vue&type=script&lang=js&"
export * from "./LedesList.vue?vue&type=script&lang=js&"
import style0 from "./LedesList.vue?vue&type=style&index=0&id=a0f09370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports